<h2>{{ 'stella.calibration_error' | translate }}</h2>